const initStaticSocialVideoReviews = (scope = document) => {
  scope.querySelectorAll('.social-video-reviews__slider--static').forEach((element) => {
    if (element.dataset.videoControlsInitialized === 'true') return;

    element.dataset.videoControlsInitialized = 'true';

    element.addEventListener('play', (event) => {
      if (event.target.tagName !== 'VIDEO') return;

      const media = event.target.closest('.social-video-reviews__media');
      media?.classList.add('is-playing');
      media?.querySelector('[data-social-video-play]')?.setAttribute('aria-label', 'Pause customer video');
    }, true);

    const showPlayState = (event) => {
      if (event.target.tagName !== 'VIDEO') return;

      const media = event.target.closest('.social-video-reviews__media');
      media?.classList.remove('is-playing');
      media?.querySelector('[data-social-video-play]')?.setAttribute('aria-label', 'Play customer video');
    };

    element.addEventListener('pause', showPlayState, true);
    element.addEventListener('ended', showPlayState, true);

    element.addEventListener('click', (event) => {
      const button = event.target.closest('[data-social-video-play]');
      if (!button) return;

      const video = button.closest('.social-video-reviews__media')?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        element.querySelectorAll('video').forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.pause();
        });
        video.play();
      } else {
        video.pause();
      }
    });
  });
};

const initSocialVideoReviews = (scope = document) => {
  if (typeof window.Swiper === 'undefined') {
    window.setTimeout(() => initSocialVideoReviews(scope), 100);
    return;
  }

  scope.querySelectorAll('[data-social-video-reviews]').forEach((element) => {
    if (element.swiper || element.dataset.swiperInitialized === 'true') return;

    element.dataset.swiperInitialized = 'true';

    const pauseVideos = () => {
      element.querySelectorAll('video').forEach((video) => {
        video.pause();
      });
    };

    element.addEventListener('play', (event) => {
      if (event.target.tagName !== 'VIDEO') return;

      const media = event.target.closest('.social-video-reviews__media');
      media?.classList.add('is-playing');
      media?.querySelector('[data-social-video-play]')?.setAttribute('aria-label', 'Pause customer video');
    }, true);

    const showPlayState = (event) => {
      if (event.target.tagName !== 'VIDEO') return;

      const media = event.target.closest('.social-video-reviews__media');
      media?.classList.remove('is-playing');
      media?.querySelector('[data-social-video-play]')?.setAttribute('aria-label', 'Play customer video');
    };

    element.addEventListener('pause', showPlayState, true);
    element.addEventListener('ended', showPlayState, true);

    new window.Swiper(element, {
      centeredSlides: true,
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 300,
      grabCursor: true,
      watchSlidesProgress: true,
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: {
        750: {
          spaceBetween: 16
        }
      },
      on: {
        slideChangeTransitionStart: pauseVideos
      }
    });

    element.addEventListener('click', (event) => {
      const button = event.target.closest('[data-social-video-play]');
      if (!button) return;

      const media = button.closest('.social-video-reviews__media');
      const video = media?.querySelector('video');
      if (!video) return;

      if (video.paused) {
        pauseVideos();
        video.play();
      } else {
        video.pause();
      }
    });
  });
};

initStaticSocialVideoReviews();
initSocialVideoReviews();

document.addEventListener('shopify:section:load', (event) => {
  initStaticSocialVideoReviews(event.target);
  initSocialVideoReviews(event.target);
});
